import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DatePickerCom from "./DatePickerCom";
import CategoryAutoComplete from "../../basic-information/productCategory/CategoryAutoComplete";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useSnackbar } from "notistack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function CategoryReport(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [state, setState] = useState({
    productID: 0,
    brandID: 0,
    groupID: 0,
    categoryID: 0,
    date1: undefined,
    date2: undefined,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    date1: false,
    date2: false,
    categoryID: false,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={props.expanded === "panel1"}
      onChange={handleChange("panel1")}
      style={{
        margin: isSmall ? 0 : "20px",
        marginBottom: isSmall && "20px",
        paddingBottom: "15px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            گزارش فروش دسته
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // border: "1px solid #e2e2e2",
            p: 1,
            py: 0,
            borderRadius: 2,
          }}
        >
          <DatePickerCom state={state} setState={setState} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: isSmall ? "100" : "40%",
              mt: 3,
            }}
          >
            {props.expanded === "panel1" && (
              <CategoryAutoComplete
                setName={setName}
                validation={errorState.categoryID}
                selectedCategoryID={state.categoryID}
                setter={setState}
                lvl1State={state}
                Offer
              ></CategoryAutoComplete>
            )}
            <Button
              disabled={!state.categoryID ? true : false}
              sx={{ ml: 2 }}
              onClick={() => {
                if (!state.date1 || !state.date2) {
                  enqueueSnackbar("لطفا تاریخ را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else if (!state.categoryID) {
                  enqueueSnackbar("لطفا دسته را انتخاب کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                } else {
                  props.callback(state);
                }
              }}
              variant="contained"
            >
              نمایش
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
